import QAcomponent from '@/components/general/QAcomponent';
import React, { useState } from 'react';
// import styles from '../styles.module.css';
import ServiceSectionHead from '../ServiceSectionHead';
import styles from '../../styles.module.css';

export default function ShopServiceQA({ className = '' }: { className?: string }) {
  const [list, setlist] = useState([
    {
      id: 1,
      question: 'روغن را خودم بیاورم ارزان‌تر است؟',
      answer:
        'بله. اگر روغن و فیلتر را خودتان تهیه کنید فقط دستمزد ۱۹۰٬۰۰۰ تومان دریافت می‌شود؛ در مرحلهٔ پرداخت گزینهٔ «فقط دستمزد» را انتخاب کنید.',
    },
    {
      id: 2,
      question: 'چه روغنی استفاده می‌شود؟',
      answer:
        'به‌صورت پیش‌فرض روغن تمام‌سینتتیک ۵W-۳۰ با استاندارد سازندهٔ خودرو. در صورت درخواست، گرید دیگری هم موجود است.',
    },
    {
      id: 3,
      question: 'خودرو باید چند ساعت بماند؟',
      answer:
        'حدود ۳۰ دقیقه. می‌توانید در محل منتظر بمانید؛ سالن انتظار و اینترنت رایگان موجود است.',
    },
    {
      id: 4,
      question: 'خدمات در محل چطور انجام می‌شود؟',
      answer:
        'کارشناس با ون مجهز به پمپ تخلیه و مخزن روغن سوخته به آدرس شما می‌آید. تنها به یک جای پارک هموار نیاز است.',
    },
  ]);

  return (
    <div className={`card ${styles.sectionMargin} ${className}`}>
      <ServiceSectionHead title="سؤال‌های پرتکرار" />
      <QAcomponent list={list} singleQaClass={`${styles.singleQaClass}`} />
    </div>
  );
}
